import { IScheduleJob } from '../common/schedule.service/schedule.job.model';
import { NotificationService } from '../common/notification.service/notification.service';
import { MaintenanceMessageService } from '../modules/maintenance.message/maintenance.message.service';
import { View } from '../common/model/view';

import * as moment from 'moment';
import { Severity } from '../common/notification.service/notification.model';
import { SignalRService } from '../services/signalr.service';
import { MessageModel } from '../modules/internal.message/model/message.model';
import { MaintenanceMessageFetchService } from '../modules';
import { AuthService } from '../services/auth.service';
import { Subscription } from 'rxjs';

export class MaintenanceNotificationJob implements IScheduleJob {
  private maintenanceMessageSubscription: Subscription;

  id = 'MaintenanceNotificationJob';
  udpateInterval = 60;
  resetCounterAt = 5;
  counter = 0;

  callback = async () => {
    if (this.signalRService.IsConnected) return;

    if (++this.counter < this.resetCounterAt) return;
    this.counter = 0;

    const m = await this.maintenanceMessageFetchService.getUpcomingMessage();
    this.displayMessage(m);
  }

  displayMessage(m: MessageModel, minutesUntil: number = -1): void {
    if (m) {
      const until = minutesUntil < 0 ? moment.duration(Math.abs(moment().diff(m.visibleFrom))).asMinutes() : minutesUntil;
      if (until > 30) return;

      if (until >= 1) {
        const minutes = Math.trunc(until);
        this.notificationService
          .showNotification('Karbantartásig még hátravan ~' + minutes + ' perc', (minutes > 5 ? Severity.info : Severity.warning), false);
      } else {
        this.notificationService
          .showNotification('A karbantartás azonnal kezdődik', Severity.errornolog, false);
      }
    }
  }

  constructor(
    private notificationService: NotificationService,
    private maintenanceMessageService: MaintenanceMessageService,
    private maintenanceMessageFetchService: MaintenanceMessageFetchService,
    private authService: AuthService,
    private signalRService: SignalRService
  ) {
    authService.getIsAuthorized().subscribe(a => {
      this.resetCounterAt = a ? 5 : 60;
    });

    signalRService.ConnectionEvents.subscribe(ce => {
      if (this.maintenanceMessageSubscription) {
        this.maintenanceMessageSubscription.unsubscribe();
        this.maintenanceMessageSubscription = undefined;
      }

      if (ce) {
        this.maintenanceMessageSubscription = signalRService.addPublishCurrentMaintenanceMessageListener().subscribe(mm => { 
          this.displayMessage(mm.upcomingMessage, mm.upcomingMessageMinutesUntil);
        });
      }
    }); 
  }
}



// WEBPACK FOOTER //
// ./src/app/schedule.jobs/maintenance.notification.job.ts